<script lang="ts">
  import type { LegalLicensesJurisdictionInfo } from '$lib/sanity/schemas/entities/LegalLicensesPage';
  import PortableText from '$components/SanityComponents/PortableText/PortableText.svelte';
  import { slugify } from '$lib/utils/slugify';
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { cx } from '@emotion/css';
  import type { ContentSourceMap } from '@sanity/client';
  import { useEncodeDataAttribute, type StudioPathLike } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';

  export let jurisdictionInfoList: LegalLicensesJurisdictionInfo[];
  export let sourceMap: ContentSourceMap | undefined = undefined;
  export let path: StudioPathLike = [];

  $: encodeDataAttribute = useEncodeDataAttribute(jurisdictionInfoList, sourceMap, sanityStudioURL);

  const responsiveVars = new ResponsiveVars()
    .addFluid('spacer', toFluidVarInput(40, 60))
    .addFluid('font-size', toFluidVarInput(16, 24))
    .toCSS();
</script>

{#each jurisdictionInfoList as jurisdictionInfo, index}
  <div class={cx('list-item', responsiveVars)}>
    <div class="anchor" id={slugify(jurisdictionInfo.jurisdiction)}>
      <h3 data-sanity={encodeDataAttribute([...path, index, 'jurisdiction'])}>
        {jurisdictionInfo.jurisdiction}
      </h3>
    </div>

    <div data-sanity={encodeDataAttribute([...path, index, 'info'])}>
      <PortableText body={jurisdictionInfo.info} />
    </div>
  </div>
{/each}

<style>
  .list-item {
    border-top: 1px solid #000;
    padding: var(--spacer) 0;
  }

  h3 {
    margin-bottom: var(--spacer);
    font-family: var(--font-family-primary);
    font-size: var(--font-size);
    line-height: 100%;
    font-weight: 700;
  }
</style>
